import httpClient from '@/utilities/service/httpClient'
import AbstractApi from '@/api/abstracts/AbstractApi'
import { AnalysisPeriodEnum } from '@/api/enums/AnalysisPeriodEnum'
// eslint-disable-next-line prettier/prettier
import type { PeriodResponseType, PeriodType } from '@/api/types/response/PeriodType'
import { PeriodDeletedType } from '@/api/types/response/PeriodType'

/**
 * @property string apiEnd /api/sales/bid/spec/{bidNumber}/{siteId}/analysis/{analysis}/{type}
 */
export default class AnalysisPeriodApi<T extends keyof typeof AnalysisPeriodEnum> extends AbstractApi {
  add(period: Array<PeriodType<T>>): Promise<PeriodResponseType<T>> {
    return httpClient.post(this.apiEnd, { period })
  }

  transfer(): Promise<PeriodResponseType<T>> {
    return httpClient.post(`${this.apiEnd}/transfer`)
  }

  delete(id: number): Promise<PeriodDeletedType> {
    return httpClient.delete(`${this.apiEnd}/${id}`)
  }

  deleteAll(): Promise<PeriodDeletedType> {
    return httpClient.delete(this.apiEnd)
  }
}
